import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class StringUtils {

    public searchString(str: string): string {
        if (!str) {
            return '';
        }
        str = str.replace(/[^a-zA-Z0-9]/g, '');
        str = str.replace(' ', '');
        return str.toLowerCase();
    }

    public uriString(str: string): string {
        if (!str) {
            return '';
        }
        str = str.replace(/[^a-zA-Z0-9\-' ']/g, '');
        str = str.replace(' ', '-');
        return str.toLowerCase();
    }
}
